export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
    console.trace(error);
  };

  nuxtApp.hook("vue:error", (error, instance, info) => {
    console.trace(error);
  });
});
